const encodeChars = [`\n`, `\r`, `\``, `'`, `"`, `<`, `>`]

export function htmlDecode(str) {
    encodeChars.forEach(char => {
        const reg = new RegExp(`U\\+${char.charCodeAt(0)};`, 'g')
        str = str.replace(reg, char)
    })
    return str
}
